import React from 'react';
import { FileCheck } from 'lucide-react';

export const QUOTE_STATUSES = [
  { value: 'draft', label: 'Draft', color: 'bg-slate-100 text-slate-700' },
  { value: 'sent', label: 'Sent', color: 'bg-blue-100 text-blue-700' },
  { value: 'accepted', label: 'Accepted', color: 'bg-green-100 text-green-700' },
  { value: 'declined', label: 'Declined', color: 'bg-red-100 text-red-700' },
  { value: 'expired', label: 'Expired', color: 'bg-amber-100 text-amber-700' },
];

export const LOST_REASONS = ['Price too high', 'Lost to competitor', 'Budget cut / project dropped', 'Delivery timeline', 'Technical mismatch', 'No response from customer', 'Relationship / vendor preference', 'Payment terms', 'Other'];

export const quoteStatusColor = (s) => QUOTE_STATUSES.find(q => q.value === s)?.color || 'bg-slate-100 text-slate-500';

const inputCls = 'w-full px-3 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900';

export const EnquiryQuoteFields = ({ formData, setFormData }) => {
  const set = (key) => (e) => setFormData({ ...formData, [key]: e.target.value });
  return (
    <div className="rounded-xl border border-purple-200 bg-purple-50/40 p-4 space-y-3" data-testid="quote-details-section">
      <div className="flex items-center gap-2">
        <FileCheck className="w-4 h-4 text-purple-600" />
        <h3 className="text-sm font-semibold text-slate-800">Quote Details</h3>
        <span className="text-xs text-slate-500">Used for quote analysis. Accepted/Declined updates the enquiry status.</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div>
          <label className="block text-xs font-medium text-slate-600 mb-1">Quote No</label>
          <input value={formData.quote_no} onChange={set('quote_no')} className={inputCls} placeholder="e.g. QT/25-26/041" data-testid="quote-no-input" />
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-600 mb-1">Quote Date</label>
          <input type="date" value={formData.quote_date} onChange={set('quote_date')} className={inputCls} data-testid="quote-date-input" />
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-600 mb-1">Quote Value (₹)</label>
          <input type="number" min="0" value={formData.quote_value} onChange={set('quote_value')} className={inputCls} placeholder="0" data-testid="quote-value-input" />
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-600 mb-1">Quote Status</label>
          <select value={formData.quote_status} onChange={set('quote_status')} className={inputCls} data-testid="quote-status-select">
            <option value="">Not quoted yet</option>
            {QUOTE_STATUSES.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-600 mb-1">Valid Until</label>
          <input type="date" value={formData.quote_valid_until} onChange={set('quote_valid_until')} className={inputCls} data-testid="quote-valid-until-input" />
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-600 mb-1">Quote Remarks</label>
          <input value={formData.quote_remarks} onChange={set('quote_remarks')} className={inputCls} placeholder="Reason won/lost, revisions..." data-testid="quote-remarks-input" />
        </div>
        {['declined', 'expired'].includes(formData.quote_status) && (
          <div className="sm:col-span-3">
            <label className="block text-xs font-medium text-red-600 mb-1">Lost Reason</label>
            <select value={formData.lost_reason || ''} onChange={set('lost_reason')} className={inputCls} data-testid="lost-reason-select">
              <option value="">Select reason</option>
              {LOST_REASONS.map(r => <option key={r} value={r}>{r}</option>)}
            </select>
          </div>
        )}
      </div>
    </div>
  );
};
